import { DUCK_FULLSCREEN_PARAM } from "duck/ui/chat/constants";

export enum RouteKey {
  Root = "root",
  Docs = "docs",
  LoginCallback = "loginCallback",
  FailureModes = "failureModes",
  FailureMode = "failureMode",
  NewFailureMode = "newFailureMode",
  ClaimAnalytics = "claimAnalytics",
  ClaimAnalyticsDetails = "claimAnalyticsDetails",
  RepairAnalytics = "repairAnalytics",
  RepairAnalyticsDetails = "repairAnalyticsDetails",
  Repairs = "repairs",
  RepairDetails = "repairDetails",
  InspectionAnalytics = "inspectionAnalytics",
  InspectionAnalyticsDetails = "inspectionAnalyticsDetails",
  CustomRecordDetails = "customRecordDetails",
  SignalEventAnalytics = "signalEventAnalytics",
  SignalEventsAnalyticsDetails = "signalEventsAnalyticsDetails",
  Dashboard = "dashboard",
  SchemaDashboard = "schemaDashboard",
  Vehicles = "vehicles",
  VinView = "vinView",
  Fleets = "fleets",
  FleetView = "fleetView",
  ServiceRecords = "serviceRecords",
  CustomSignalEvents = "customSignalEvents",
  NewCustomSignalEvent = "newCustomSignalEvent",
  CustomSignalEvent = "customSignalEvent",
  Version = "version",
  Groups = "groups",
  Group = "group",
  AttributesConfig = "attributesConfig",
  PagesConfig = "pagesConfig",
  DashboardConfig = "dashboardConfig",
  GeneralConfig = "generalConfig",
  BrandingConfig = "brandingConfig",
  Info = "info",
  AdminGroups = "adminGroups",
  Users = "users",
  SuperAdminGroups = "superAdminGroups",
  VehicleImages = "vehicleImages",
  NotFound = "notFound",
  WorkOrders = "workOrders",
  WorkOrderDetails = "workOrderDetails",
  WorkOrderVerifications = "workOrdersVerification",
  WorkOrderVerificationDetails = "workOrderVerificationDetails",
  WorkOrdersVerificationNew = "workOrdersVerificationNew",
  RepairParts = "repairParts",
  RepairLabor = "repairLabor",
  SmartGroup = "smartGroup",
  Investigator = "investigator",
  IssueInvestigator = "issueInvestigator",
  DuckSharedThread = "duckSharedThread",
  DuckAssistant = "duckAssistant",
  DuckConfig = "duckConfig",
  Directives = "directives",
  DirectiveNew = "directiveNew",
  Directive = "directive",
  DuckChatTools = "duckChatTools",
  ClaimAnalyticsView = "claimAnalyticsView",
  SignalEventAnalyticsView = "signalEventAnalyticsView",
  Assets = "assets",
  Asset = "asset",
  Data = "data",
  NewData = "newData",
  DataUpload = "dataUpload",
  DataTable = "dataTable",
  DataTableEdit = "dataTableEdit",
  DataImport = "dataImport",
  ReplaceDataFeed = "replaceDataFeed",
  ReplaceDataFeedConnection = "replaceDataFeedConnection",
  Connections = "connections",
  NewConnection = "newConnection",
  NewConnectorConnection = "newConnectorConnection",
  Connection = "connection",
  NewDataFeed = "newDataFeed",
  DataFeed = "dataFeed",
  SchemaDefinitions = "schemaDefinitions",
  SchemaDefinition = "schemaDefinition",
  SchemaDashboardConfig = "schemaDashboardConfig",
  SchemaDetailsPageConfig = "schemaDetailsPageConfig",
  SchemaMobileDashboardConfig = "schemaMobileDashboardConfig",
  SchemaMobileDetailsPageConfig = "schemaMobileDetailsPageConfig",
  SchemaMobileListingPageConfig = "schemaMobileListingPageConfig",
  SchemaAttributesConfig = "schemaAttributesConfig",
  NewSchemaDefinition = "newSchemaDefinition",
  SchemaRecords = "schemaRecords",
  SchemaRecord = "schemaRecord",
  SchemaEventAnalytics = "schemaEventAnalytics",
  SchemaInvestigator = "schemaInvestigator",
  SchemaInvestigatorById = "schemaInvestigatorById",
  Issues = "issues",
  AIKnowledge = "aiKnowledge",
  KnowledgeRepoManagement = "knowledgeRepoManagement",
  TireSettings = "tireSettings",
  KpiTargets = "kpiTargets",
  Duck2SiemsJobStatus = "duck2SiemsJobStatus",
  UserPreferences = "userPreferences",
  EmailNotifications = "emailNotifications",
  EmailPipelineWorkflows = "emailPipelineWorkflows",
  NewEmailPipelineWorkflow = "newEmailPipelineWorkflow",
  EmailPipelineWorkflow = "emailPipelineWorkflow",
  Localization = "localization",
  Schedules = "schedules",
  AgenticTools = "agenticTools",
  AgenticTool = "agenticTool",
}

export const routes: Record<RouteKey, string> = {
  [RouteKey.Root]: "/",
  [RouteKey.Docs]: "/docs",
  [RouteKey.LoginCallback]: "/login/callback",
  [RouteKey.FailureModes]: "/failure-modes",
  [RouteKey.FailureMode]: "/failure-modes/:id",
  [RouteKey.NewFailureMode]: "/failure-modes/new",
  [RouteKey.ClaimAnalytics]: "/claim-analytics",
  [RouteKey.ClaimAnalyticsView]: "/claim-analytics/view/:viewTitle",
  [RouteKey.ClaimAnalyticsDetails]: "/claim-analytics/:id",
  [RouteKey.RepairAnalytics]: "/repair-analytics",
  [RouteKey.RepairAnalyticsDetails]: "/repair-analytics/:id",
  [RouteKey.Repairs]: "/repairs",
  [RouteKey.RepairDetails]: "/repairs/:id",
  [RouteKey.InspectionAnalytics]: "/inspection-analytics",
  [RouteKey.InspectionAnalyticsDetails]: "/inspection-analytics/:id",
  [RouteKey.CustomRecordDetails]: "/custom-records/:id",
  [RouteKey.SignalEventAnalytics]: "/signal-event-analytics",
  [RouteKey.SignalEventAnalyticsView]:
    "/signal-event-analytics/view/:viewTitle",
  [RouteKey.SignalEventsAnalyticsDetails]:
    "/signal-event-analytics/:id/:recordedAt",
  [RouteKey.Dashboard]: "/dashboard/:id",
  [RouteKey.SchemaDashboard]: "/dashboard",
  [RouteKey.Vehicles]: "/vehicles",
  [RouteKey.VinView]: "/vehicles/:vin",
  [RouteKey.Fleets]: "/fleets",
  [RouteKey.FleetView]: "/fleets/:fleetName",
  [RouteKey.ServiceRecords]: "/service-records",
  [RouteKey.CustomSignalEvents]: "/custom-signal-events",
  [RouteKey.NewCustomSignalEvent]: "/custom-signal-events/new",
  [RouteKey.CustomSignalEvent]: "/custom-signal-events/:id",
  [RouteKey.Version]: "/version",
  [RouteKey.Groups]: "/groups",
  [RouteKey.Group]: "/groups/:id",
  [RouteKey.AttributesConfig]: "/superadmin/attributes",
  [RouteKey.PagesConfig]: "/superadmin/pages",
  [RouteKey.DashboardConfig]: "/superadmin/dashboard-config",
  [RouteKey.GeneralConfig]: "/superadmin/general",
  [RouteKey.BrandingConfig]: "/superadmin/branding",
  [RouteKey.Info]: "/superadmin/info",
  [RouteKey.VehicleImages]: "/superadmin/vehicle-images",
  [RouteKey.AdminGroups]: "/admin/groups",
  [RouteKey.Users]: "/admin/users",
  [RouteKey.SuperAdminGroups]: "/superadmin/groups",
  [RouteKey.WorkOrders]: "/work-orders",
  [RouteKey.WorkOrderDetails]: "/work-orders/:id",
  [RouteKey.WorkOrderVerifications]: "/work-order-verifications",
  [RouteKey.WorkOrderVerificationDetails]: "/work-order-verifications/:id",
  [RouteKey.WorkOrdersVerificationNew]: "/work-order-verifications/new",
  [RouteKey.RepairParts]: "/repair-parts",
  [RouteKey.RepairLabor]: "/repair-labor",
  [RouteKey.SmartGroup]: "/investigator/smart-group/:id",
  [RouteKey.IssueInvestigator]: "/investigator/:issueId",
  [RouteKey.Investigator]: "/investigator",
  [RouteKey.DuckSharedThread]: "/duck/shared/:shareId",
  [RouteKey.DuckAssistant]: "/duck-assistant",
  [RouteKey.DuckConfig]: "/duck-config",
  [RouteKey.Directives]: "/directives",
  [RouteKey.DirectiveNew]: "/directives/new",
  [RouteKey.Directive]: "/directives/:id",
  [RouteKey.DuckChatTools]: "/duck-chat-tools",
  [RouteKey.Assets]: "/assets",
  [RouteKey.Asset]: "/assets/:id",
  [RouteKey.Data]: "/data-tables",
  [RouteKey.NewData]: "/data-tables/new",
  [RouteKey.DataUpload]: "/data-tables/uploads/:id",
  // Sits below the two static children above, which the router matches first.
  [RouteKey.DataTable]: "/data-tables/:id",
  [RouteKey.DataTableEdit]: "/data-tables/:id/edit",
  [RouteKey.DataImport]: "/data-tables/:id/import",
  [RouteKey.ReplaceDataFeed]: "/data-tables/:id/feed/replace",
  [RouteKey.ReplaceDataFeedConnection]:
    "/data-tables/:id/feed/replace/:connectionID",
  [RouteKey.Connections]: "/connections",
  [RouteKey.NewConnection]: "/connections/new",
  [RouteKey.NewConnectorConnection]: "/connections/new/:connectorID",
  // Sits below the static child above, which the router matches first.
  [RouteKey.Connection]: "/connections/:id",
  [RouteKey.NewDataFeed]: "/connections/:id/feeds/new",
  [RouteKey.DataFeed]: "/connections/:id/feeds/:feedID",
  [RouteKey.SchemaDefinitions]: "/superadmin/schema-definitions",
  [RouteKey.SchemaDefinition]: "/superadmin/schema-definitions/:id",
  [RouteKey.SchemaDashboardConfig]:
    "/superadmin/schema-definitions/:id/dashboard-views",
  [RouteKey.SchemaDetailsPageConfig]:
    "/superadmin/schema-definitions/:id/details-page",
  [RouteKey.SchemaMobileDashboardConfig]:
    "/superadmin/schema-definitions/:id/mobile-dashboard-views",
  [RouteKey.SchemaMobileDetailsPageConfig]:
    "/superadmin/schema-definitions/:id/mobile-details-page",
  [RouteKey.SchemaMobileListingPageConfig]:
    "/superadmin/schema-definitions/:id/mobile-listing-page",
  [RouteKey.SchemaAttributesConfig]:
    "/superadmin/schema-definitions/:id/attributes",
  [RouteKey.NewSchemaDefinition]: "/superadmin/schema-definitions/new",
  [RouteKey.EmailNotifications]: "/superadmin/email-notifications",
  [RouteKey.EmailPipelineWorkflows]: "/superadmin/email-pipeline-workflows",
  [RouteKey.NewEmailPipelineWorkflow]:
    "/superadmin/email-pipeline-workflows/new",
  [RouteKey.EmailPipelineWorkflow]: "/superadmin/email-pipeline-workflows/:id",
  [RouteKey.Localization]: "/superadmin/localization",
  [RouteKey.Schedules]: "/schedules",
  [RouteKey.SchemaEventAnalytics]: "/:tableType/:schemaName/analytics",
  [RouteKey.SchemaInvestigator]: "/:tableType/:schemaName/investigator",
  [RouteKey.SchemaInvestigatorById]: "/investigations/:investigationId",
  [RouteKey.SchemaRecords]: "/:tableType/:schemaName/records",
  [RouteKey.SchemaRecord]: "/:tableType/:schemaName/records/:id",
  [RouteKey.Issues]: "/issues",
  [RouteKey.AIKnowledge]: "/ai-knowledge",
  [RouteKey.KnowledgeRepoManagement]: "/superadmin/knowledge-repo",
  [RouteKey.TireSettings]: "/tire-settings",
  [RouteKey.KpiTargets]: "/kpi-targets",
  [RouteKey.Duck2SiemsJobStatus]: "/duck-to-siems-job-status",
  [RouteKey.UserPreferences]: "/user-preferences",
  [RouteKey.AgenticTools]: "/agentic-tools",
  [RouteKey.AgenticTool]: "/agentic-tools/:id",
  [RouteKey.NotFound]: "*",
};

// we keep a list of all routes we have changed and want to keep the old links working
export const redirects = Object.freeze({
  "/campaigns/scoping": "/vehicles",
  "/campaign-scoping": "/vehicles",
  "/service-events": "/service-records",
  "/signal-event-studio": "/custom-signal-events",
  "/duck": `/?${DUCK_FULLSCREEN_PARAM}=true`,
});
